import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/main.scss';
//# sourceMappingURL=index.mjs.map
